import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {Temporal} from "temporal-polyfill";
import TokenClientConfig = google.accounts.oauth2.TokenClientConfig;
import Instant = Temporal.Instant;
import TokenResponse = google.accounts.oauth2.TokenResponse;
import ClientConfigError = google.accounts.oauth2.ClientConfigError;
import {Injectable} from "@angular/core";

const debug = initDebugger('GoogleLogin');

/** Tjeneste for å hente brukers google oauthtoken, hentes vhja Google Identity Services JavaScript SDK. */
@Injectable()
export class GoogleLogin {

    /** oauth scope som forespørres ved autentisering mot google - ber om tilgang til filer i google drive. */
    static oauthscope = 'https://www.googleapis.com/auth/drive.file';

    /** sist hentede token */
    private oauthToken: Promise<TokenResponse> | null = null;
    /** Tidspunktet oauthToken utløper, etter dette må nytt token hentes. */
    private oauthTokenUtløper: Instant | null = null;

    constructor() {
    }

    async hentOauthToken(clientId: string): Promise<string> {
        //token har aldri vært forespurt, eller allerede hentet token er utløpt på tid
        if (erNil(this.oauthToken) || this.erTokenUtløp()) {
            this.oauthToken = this.hentNyttOauthToken(clientId);
            this.oauthTokenUtløper = Temporal.Now.instant().add({seconds: Number((await this.oauthToken).expires_in)});
        }

        debug('hentOauthToken: resolver token');
        const token = await this.oauthToken;
        debug('hentOauthToken: returnerer token', token);
        return token.access_token;
    }

    deinitialiser(){
        this.oauthToken = null;
    }

    /* ikke tatt i bruk
    logut(){
        //google.accounts.oauth2.revoke(accessToken);
    }*/

    //private hjelpemetoder

    /** sann dersom det er mindre enn ett minutt igjen av tokenets varighet*/
    private erTokenUtløp(): boolean {
        if (erNil(this.oauthToken) || erNil(this.oauthTokenUtløper)) return true;

        //sørger for at vi ber om nytt token når det er mindre enn ett minutt igjen av tokenets varighet
        return this.oauthTokenUtløper!.epochSeconds < Temporal.Now.instant().subtract({minutes: 1}).epochSeconds;
    }

    private hentNyttOauthToken(clientId: string): Promise<TokenResponse> {
        debug('hentNyttOauthToken')
        return new Promise<TokenResponse>((resolve, reject) => {
            google.accounts.oauth2.initTokenClient(<TokenClientConfig>{
                client_id: clientId,
                scope: GoogleLogin.oauthscope,
                callback: (tokenResponse: TokenResponse) => {
                    if (erIkkeNil(tokenResponse.error)) {
                        debug('hentNyttOauthToken:callback error', tokenResponse);
                        reject(tokenResponse.error);
                        return;
                    }
                    debug('hentNyttOauthToken:callback, nytt token hentet', tokenResponse);
                    resolve(tokenResponse);
                },
                error_callback: (error: ClientConfigError) => {
                    debug('hentNyttOauthToken:error_callback', error);
                    reject(error);
                }
            }).requestAccessToken();
        });
    }
}
